import NextUpCards from './NextUpCards';

export default NextUpCards;
